import { isElement } from './isElement';
import { selectOne } from './selectOne';
/**
 * Select all DOM elements that match a query selector
 */
export function selectAll(
/**
 * Query selector
 */
selector, 
/**
 * A parent for the needed elements
 */
parent) {
    if (selector instanceof NodeList) {
        return selector;
    }
    if (isElement(selector)) {
        return [selector];
    }
    if (Array.isArray(selector)) {
        return selector;
    }
    // if string
    if (typeof parent !== 'undefined') {
        const parenEl = selectOne(parent);
        if (parenEl) {
            return parenEl.querySelectorAll(selector);
        }
    }
    return document.querySelectorAll(selector);
}
